Util = require 'lib/util'

module.exports = window.IdCache = new class
  constructor: ->
    @_shortLinkToId =
      Card: {}
      Board: {}
    @_idCardToIdBoard = {}

  getId: (typeName, id) ->
    if Util.checkId(id)
      id
    else if Util.isShortLink(id)
      @_shortLinkToId[typeName][id]
    else
      throw new Error("Not a shortLink or id: #{id}")

  setId: (typeName, shortLink, id) ->
    if !Util.checkId(id)
      throw new Error("Not an id: #{id}")
    if !Util.isShortLink(shortLink)
      throw new Error("Not a shortLink: #{shortLink}")
    @_shortLinkToId[typeName][shortLink] = id

  setCardId: (shortLink, id) ->
    @setId('Card', shortLink, id)

  setBoardId: (shortLink, id) ->
    @setId('Board', shortLink, id)

  getCardId: (id) ->
    @getId('Card', id)

  getBoardId: (id) ->
    @getId('Board', id)



// WEBPACK FOOTER //
// ./app/scripts/db/id-cache.coffee